import * as contextmenu from 'components/ContextMenu';
import navigateToURL from 'lib/navigateToURL';
import preferences from 'Preferences';
import {getTestDefinitionURL} from 'sample-tests/network/TestDefinitionDAO';
import copyToClipboard from 'util/clipboard/copyToClipboard';

import {TestDefinitionListingGraphQL} from '../../../graphql-fragments/sample_tests/__generated/TestDefinitionListingGraphQL';

export function getContextMenuOptions(
  testDefinition: TestDefinitionListingGraphQL
): Array<contextmenu.ContextMenuOption> {
  return [
    {
      name: 'Open',
      click: () => {
        navigateToURL(getTestDefinitionURL(testDefinition.id));
      },
    },
    {
      name: 'Copy API ID',
      click: () => {
        copyToClipboard(testDefinition.id, {showToastOnSuccess: true});
      },
      hide: () => !preferences.get('ENABLE_COPY_API_ID'),
    },
  ];
}

export function open(e: Event, testDefinition: TestDefinitionListingGraphQL): void {
  contextmenu.view.open(e, getContextMenuOptions(testDefinition));
}
